// Entry: mount the routed App. `/docs/:docId` is the live reader; the
// slice-1 demo screen is still reachable via the `/demo` route until we
// retire it. Tokens are imported by App for the routed surface.

import { createRoot } from "react-dom/client";
import { App } from "./app";

createRoot(document.getElementById("root")!).render(<App />);
